export default {
  NO_PERMISSION_TOOLTIP: 'У вас немає прав для цієї дії',
  STATISTICS_TITLE: 'Статистика транзакцій по додатках',
  PRICING_TITLE: 'Тарифні плани клієнта',
  PRICING_PLAN_PER_ITEMS: 'Ціна за одиницю',
  PRICING_MONTHLY_FEE: 'Щомісячна плата',
  PRICING_MAX_VERIFICATION: 'Максимальна кількість верифікацій',

  INVOICE_TITLE: 'Рахунок-фактура',
  INVOICE_ACCOUNT: 'Номер рахунку',
  BANK_TRANSFER: 'Банківський трансфер',
  NEW_INVOICE: 'новий',
  BILLING_STATISTICS: 'Статистика рахунків клієнта',
  STATISTICS_COUNT: 'Рахунок',

  PRICING_MONTHLY_TOTAL: 'Всього за місяць',
  PRICING_EXTRA_FEE: 'Додаткова плата',
  PRICING_TEST_VERIFICATION: 'Тестова кількість верифікацій',

  REQUEST_SCALE_PLAN_TITLE: 'Запит на індивідуальний план Scale',
  REQUEST_SCALE_PLAN_DESCRIPTION:
    'Розкажіть про очікуваний обсяг верифікацій та поділіться деталями, які допоможуть нам підготувати індивідуальну цінову пропозицію.',
  ESTIMATED_VOLUME: 'Очікуваний обсяг верифікацій',
  ESTIMATED_VOLUME_PLACEHOLDER: 'напр. 10 000 на місяць',
  ESTIMATED_VOLUME_HINT: 'Достатньо приблизної кількості',
  CONTACT_EMAIL: 'Контактний email',
  CONTACT_EMAIL_PLACEHOLDER: 'name@company.com',
  CONTACT_EMAIL_HINT: "Ми зв'яжемося з вами на цей email",
  ADDITIONAL_DETAILS: 'Додаткові деталі',
  ADDITIONAL_DETAILS_PLACEHOLDER: 'Сценарій використання, регіони, вимоги комплаєнсу',
  ADDITIONAL_DETAILS_HINT: "Необов'язково, але допомагає підготувати точнішу пропозицію",
  REQUEST_PRICING: 'Запросити ціну',
  VOLUME_REQUIRED: 'Вкажіть очікуваний обсяг',
  EMAIL_REQUIRED: 'Вкажіть контактний email',
  EMAIL_INVALID: 'Вкажіть коректний email',
  REQUEST_SENT_TITLE: 'Запит надіслано',
  REQUEST_SENT_DESCRIPTION:
    "Дякуємо за звернення. Наша команда розгляне ваш запит та зв'яжеться з вами найближчим часом з індивідуальною ціновою пропозицією.",
  REQUEST_SENT_EMAIL_NOTE: "Ми зв'яжемося з вами на вказаний email.",
  CLOSE: 'Закрити',

  BILLING: 'Білінг',
  MONTHLY: 'Щомісячно',
  ANNUALLY: 'Щорічно',
  ANNUAL_DISCOUNT: 'Знижка 10%',
  PER_MONTH: 'за місяць',
  PER_YEAR: 'за рік',
  FOR_MONTHS: 'за {{period}} міс.',
  FOR_YEARS: 'за {{period}} р.',
  RENEWS_ON: 'Поновлюється {{date}}',
  FROM: 'від',
  CUSTOM: 'Індивідуальний',
  CONTINUE_WITH: 'Продовжити з {{plan}}',
  CURRENT_PLAN: 'Поточний план',
  PREPARED_FOR_YOU: 'Підготовлено для вас',
  DOWNGRADE: 'Знизити план',
  LETS_TALK: "Зв'язатися",
  SERVICES_DESCRIPTION: 'Списання за сервіси (з передоплаченого балансу)',
  SERVICES_SUBTITLE: 'Вищі плани дають нижчу вартість за перевірку.',
  CUSTOM_PRICE: 'індивідуально',

  PLAN_STARTUP: 'Startup',
  PLAN_GROWTH: 'Growth',
  PLAN_SCALE: 'Scale',

  STARTUP_DESCRIPTION:
    'Ідеально для початку регульованого бізнесу.<br/><br/>Все необхідне для дотримання вимог з першого дня.',
  GROWTH_DESCRIPTION:
    'Ідеально для компаній, що розширюють клієнтську базу.<br/><br/>Забезпечте економічний комплаєнс у міру зростання бізнесу.',
  SCALE_DESCRIPTION:
    'Найкраще для високонавантажених клієнтів.<br/><br/>Максимізуйте ефективність комплаєнсу з преміальним пакетом та найбільшими знижками.',

  SERVICE_ID_VERIFICATION: 'Перевірка ідентифікаційних даних',
  SERVICE_LIVENESS: 'Живість і зіставлення обличчя',
  SERVICE_UNIQUENESS: 'Перевірка унікальної особи',
  SERVICE_AML: 'Перевірка AML',
  SERVICE_MONITORING: 'Безперервний моніторинг (річний)',
  SERVICE_ADDRESS_VERIFICATION: 'Перевірка адреси (без документів)',
  SERVICE_PROOF_OF_ADDRESS: 'Підтвердження адреси (за документом)',
  SERVICE_WALLET: 'Перевірка гаманця / транзакцій',
  SERVICE_WALLET_MONITORING: 'Моніторинг гаманця',
  SERVICE_EMAIL_OTP: 'Перевірка електронної пошти (otp)',
  SERVICE_EMAIL_VALIDATION: 'Валідація електронної пошти',
  SERVICE_PHONE_SMS: 'Перевірка телефону (sms)',
  SERVICE_PHONE_CALL: 'Перевірка телефону (дзвінок)',
  SERVICE_PHONE_VALIDATION: 'Перевірка телефону',
  SERVICE_PHONE_HRL: 'HLR-перевірка телефону (перевірка оператора)',
  SERVICE_QUESTIONNAIRE: 'Анкета',
  SERVICE_SUPPORT: 'Підтримка',
  SERVICE_CONTRACT: 'Контракт включено',

  SERVICE_UNIQUENESS_TOOLTIP: 'Підтверджує реальну, унікальну особу в базі користувачів.',
  SERVICE_MONITORING_TOOLTIP:
    'Безперервно відстежуйте відповідність AML, отримуючи сповіщення про будь-яку підозрілу активність або зміни статусу.',
  SERVICE_ADDRESS_VERIFICATION_TOOLTIP: 'Перевіряє адресу користувача без необхідності документів.',
  SERVICE_PROOF_OF_ADDRESS_TOOLTIP:
    'Перевіряє адресу користувача за офіційним документом, наприклад комунальним рахунком або банківською випискою.',
  SERVICE_WALLET_TOOLTIP:
    'Безпечно моніторте криптогаманці користувачів та перевіряйте деталі транзакцій у реальному часі. Це надає зручний спосіб відстежувати баланси, історію транзакцій і підтвердження, забезпечуючи прозорість і контроль над вашими цифровими активами.',
  SERVICE_WALLET_MONITORING_TOOLTIP:
    'Відстежує активність гаманця, списуючи 10 запитів на старт і один запит за кожну нову виявлену транзакцію.',
  SERVICE_EMAIL_VALIDATION_TOOLTIP: 'Перевіряє, що email справжній, активний і не одноразовий.',
  SERVICE_PHONE_VALIDATION_TOOLTIP: 'Підтверджує, що номер телефону дійсний, доступний і не тимчасовий.',
  SERVICE_PHONE_HRL_TOOLTIP:
    'Перевіряє у мобільного оператора, що номер активний і закріплений за абонентом.',

  BILLING_DETAILS_TITLE: 'Деталі оплати',
  BILLING_DETAILS_DESCRIPTION:
    'Ця інформація потрібна для виставлення рахунків та дотримання вимог оподаткування. На наступному кроці вас буде перенаправлено на сторінку оплати.',
  COUNTRY_OF_REGISTRATION: 'Країна реєстрації',
  SELECT_COUNTRY: 'Оберіть країну',
  VAT_NUMBER: 'Податковий номер',
  VAT_NUMBER_PLACEHOLDER: 'напр. ІПН, ЄДРПОУ або номер компанії',
  VAT_NUMBER_HINT: 'Ваш податковий або реєстраційний номер компанії',
  BILLING_EMAIL: 'Email для рахунків',
  BILLING_EMAIL_PLACEHOLDER: 'name@company.com',
  BILLING_EMAIL_HINT: 'Рахунки та оновлення щодо оплати надсилатимуться на цей email',
  ADDRESS_LINE1: 'Адреса (рядок 1)',
  ADDRESS_LINE1_PLACEHOLDER: 'Вулиця, будинок',
  ADDRESS_LINE2: 'Адреса (рядок 2)',
  ADDRESS_LINE2_PLACEHOLDER: 'Квартира, офіс тощо',
  CITY: 'Місто',
  CITY_PLACEHOLDER: 'Місто',
  STATE: 'Область / Регіон',
  STATE_PLACEHOLDER: 'Область або регіон',
  POSTAL_CODE: 'Поштовий індекс',
  POSTAL_CODE_PLACEHOLDER: 'Поштовий індекс',
  PHONE_NUMBER: 'Номер телефону',
  PHONE_NUMBER_PLACEHOLDER: '+380123456789',
  SIGNED_AGREEMENT: 'Я хочу продовжити з підписаним договором',
  SIGNED_AGREEMENT_TOOLTIP:
    "Наша команда розгляне ваш запит та зв'яжеться з вами для оформлення контрактної оплати.",
  BACK: 'Назад',
  CONTINUE_TO_PAYMENT: 'Продовжити до оплати',
  SAVE: 'Зберегти',
  COUNTRY_REQUIRED: 'Оберіть країну',
  VAT_NUMBER_REQUIRED: 'Вкажіть податковий номер',
  VAT_NUMBER_INVALID: 'Вкажіть коректний податковий номер',
  BILLING_EMAIL_REQUIRED: 'Вкажіть email для рахунків',
  BILLING_EMAIL_INVALID: 'Вкажіть коректний email',
  ADDRESS_LINE1_REQUIRED: 'Вкажіть адресу',
  CITY_REQUIRED: 'Вкажіть місто',
  POSTAL_CODE_REQUIRED: 'Вкажіть поштовий індекс',
  PHONE_NUMBER_REQUIRED: 'Вкажіть номер телефону',
  PHONE_NUMBER_INVALID: 'Вкажіть коректний номер телефону',
  FIELD_TOO_LONG: 'Занадто довге значення',
  SOMETHING_WENT_WRONG: 'Щось пішло не так. Спробуйте ще раз.',

  CURRENT_PLAN_LABEL: 'Поточний план',
  UPGRADE: 'Покращити',
  UPGRADE_PLAN: 'Покращити план',
  PAY_NOW: 'Оплатити',
  CANCEL_SUBSCRIPTION: 'Скасувати підписку',
  CHANGE_PAYMENT_INFORMATION: 'Змінити платіжні дані',
  NEED_TO_PAY: 'ПОТРІБНА ОПЛАТА',
  TRIAL_PERIOD: 'Пробний період',
  TRIAL_SUFFIX: 'Пробний',
  DAYS_REMAINING: 'Залишилось {{days}} днів',
  ENDS_ON: 'Закінчується {{date}}',
  TRIAL_DESCRIPTION: '{{days}}-денний пробний період з {{balance}} кредитів',
  TRIAL_FEATURE_CREDITS: 'Кредити на верифікацію',
  TRIAL_FEATURE_ACCESS: 'Повний доступ до платформи під час пробного періоду',
  TRIAL_FEATURE_TOPUP: 'Можливість поповнити кредити в будь-який час',
  TRIAL_WARNING: 'Після закінчення пробного періоду доступ буде призупинено до активації платного плану.',
  VIEW_PRICING_PLANS: 'Переглянути тарифні плани',
  TRIAL_ENDED_TITLE: 'Ваш пробний період завершено',
  TRIAL_ENDED_DESCRIPTION:
    'Оберіть тарифний план, щоб продовжити користуватися платформою та отримати доступ до всіх сервісів верифікації.',
  BANNER_TRIAL_ACTIVE_TITLE: 'Пробний період активний · залишилось {{days}} днів.',
  BANNER_TRIAL_ACTIVE_TEXT:
    'Оновіть план, щоб увімкнути Live-режим та зберегти безперервний доступ після завершення пробного періоду.',
  BANNER_TRIAL_ENDED_TITLE: 'Ваш пробний період завершено.',
  BANNER_TRIAL_ENDED_TEXT:
    'Оберіть тарифний план, щоб продовжити користуватися платформою та отримати доступ до всіх сервісів верифікації.',
  BANNER_GO_TO_BILLING: 'Перейти до білінгу',
  FEATURE_PREMIUM: 'Краща ціна',
  FEATURE_SUPPORT: 'Нижчі витрати на використання',
  FEATURE_SECURITY: 'Ті самі функції, більша вигода',
  FEATURE_CUSTOM_LIMITS: 'Усі індивідуальні ліміти',
  FEATURE_FULL_ACCESS: 'Повний доступ до платформи',
  FEATURE_USAGE_BASED: 'Оплата залежно від використання',
  FEATURE_VOLUME_DISCOUNTS: "Знижки зі зростанням об'ємів",
  FEATURE_LOWER_COSTS: 'Перейдіть на вищий тариф, щоб знизити вартість верифікації',

  BALANCE: 'Баланс',
  TRIAL_BALANCE: 'Пробний баланс',
  MINIMUM_BALANCE: 'Мінімальний баланс:',
  REPLENISH: 'Поповнити',
  PAYMENT_METHOD: 'Спосіб оплати',
  CARD_EXPIRES: 'Діє до {{date}}',
  CARD_ACTIVE: 'Активна',
  UPDATE: 'Оновити',
  REFILL_BALANCE: 'Поповнити баланс',
  REFILL_BALANCE_TITLE: 'Поповнити баланс',
  REFILL_BALANCE_DESCRIPTION: 'Введіть суму, яку ви хочете додати до балансу.',
  REFILL_AMOUNT_PLACEHOLDER: 'Введіть суму',
  REFILL_MIN_AMOUNT: 'Мінімальна сума поповнення — {{amount}}',
  REFILL_MAX_AMOUNT: 'Максимальна сума поповнення — {{amount}}',
  REFILL_CONFIRM: 'Перейти до оплати',
  CANCEL: 'Скасувати',
  PAID: 'Оплачено',
  INVOICE_PAID: 'Оплачено',
  INVOICE_UNPAID: 'Неоплачено',
  INVOICE_EXPIRED: 'Прострочено',
  INVOICE_CANCELED: 'Скасовано',

  TX_NAME: 'Назва',
  TX_AMOUNT: 'Сума',
  TX_STATUS: 'Статус',
  TX_TYPE: 'Тип',
  TX_DATE_TIME: 'Дата і час',
  TX_ACTIONS: 'Дії',
  TX_TYPE_INVOICE: 'Інвойс',
  TX_TYPE_REPLENISH: 'Поповнення',
  TX_DOWNLOAD: 'Завантажити',
  TX_DOWNLOAD_FORMAT: 'PDF',
  TX_ROWS_PER_PAGE: 'Рядків на сторінці:',
  INVOICES_RECEIPTS: 'Рахунки та квитанції',

  OUT_OF_CREDITS_TITLE: 'Ой! Ваші кредити закінчились.',
  OUT_OF_CREDITS_DESCRIPTION:
    'Щоб продовжити користуватися сервісом без перерв та мати доступ до всіх функцій, поповніть баланс зараз.',

  USAGE: 'Використання',
  TIMES: '{{count}} разів',
  USAGE_MODE_LIVE: 'Live',
  USAGE_MODE_TEST: 'Test',
  USAGE_EMPTY: 'Немає використання за обраний період',
  USAGE_TOTAL: 'Разом',
  USAGE_ERROR_BUSY: 'Сервіс використання зайнятий. Спробуйте ще раз за мить.',
  USAGE_ERROR_INVALID: 'Запит відхилено: {{message}}',
  USAGE_ERROR_GENERIC: 'Не вдалося завантажити використання.',
  USAGE_ERROR_RANGE: 'Цей період не підтримується. Оберіть період не довший за {{max}} днів.',
  USAGE_RETRY: 'Повторити',

  PERIOD_STATEMENTS_TITLE: 'Підсумки розрахункових періодів',
  PERIOD_STATEMENTS_DESCRIPTION:
    'Використання, мінімальне зобов’язання та списання з балансу за завершені розрахункові періоди.',
  PERIOD_STATEMENTS_EMPTY: 'Завершених розрахункових періодів ще немає.',
  PERIOD_STATEMENTS_ERROR: 'Не вдалося завантажити підсумки розрахункових періодів: {{message}}',
  PERIOD_STATEMENTS_LOADING: 'Завантаження підсумків розрахункових періодів',
  PERIOD_STATEMENTS_PAGINATION: '{{from}}–{{to}} із {{count}}',
  PERIOD_STATEMENTS_PAGINATION_FIRST: 'Перейти на першу сторінку розрахункових періодів',
  PERIOD_STATEMENTS_PAGINATION_PREVIOUS: 'Перейти на попередню сторінку розрахункових періодів',
  PERIOD_STATEMENTS_PAGINATION_NEXT: 'Перейти на наступну сторінку розрахункових періодів',
  PERIOD_STATEMENTS_PAGINATION_LAST: 'Перейти на останню сторінку розрахункових періодів',
  PERIOD_STATEMENT_PERIOD: 'Розрахунковий період',
  PERIOD_STATEMENT_USAGE: 'Використання',
  PERIOD_STATEMENT_MINIMUM_COMMITMENT: 'Мінімальне зобов’язання',
  PERIOD_STATEMENT_BALANCE_ADJUSTMENT: 'Списано з балансу',
  PERIOD_STATEMENT_RESULT: 'Результат',
  PERIOD_STATEMENT_RESULT_MINIMUM_MET: 'Мінімум виконано',
  PERIOD_STATEMENT_RESULT_DIFFERENCE_DEBITED: 'Невикористане списано',
  PERIOD_STATEMENT_RESULT_PARTIALLY_DEBITED: 'Списано частково',
  PERIOD_STATEMENT_RESULT_NOT_DEBITED: 'Не списано',
  PERIOD_STATEMENT_EXPAND: 'Розгорнути розрахунковий період',
  PERIOD_STATEMENT_COLLAPSE: 'Згорнути розрахунковий період',
  PERIOD_STATEMENT_USAGE_BREAKDOWN: 'Деталізація використання',
  PERIOD_STATEMENT_SERVICE: 'Сервіс',
  PERIOD_STATEMENT_COUNTRY: 'Країна',
  PERIOD_STATEMENT_REQUESTS: 'Запити',
  PERIOD_STATEMENT_AMOUNT: 'Сума',
  PERIOD_STATEMENT_NO_USAGE: 'У цьому розрахунковому періоді не було списань.',
  PERIOD_STATEMENT_UNUSED_MINIMUM: 'Невикористана частина мінімуму',
  PERIOD_STATEMENT_DEBITED: 'Списано з балансу',
  PERIOD_STATEMENT_DEBITED_AT: 'Дата списання',
  PERIOD_STATEMENT_HINT_PERIOD: 'Дні розрахункового періоду за UTC.',
  PERIOD_STATEMENT_HINT_USAGE: 'Загальна сума списань за ваші верифікації та перевірки за період.',
  PERIOD_STATEMENT_HINT_MINIMUM_COMMITMENT: 'Найменша сума, яку ваш тариф вимагає витратити за один період.',
  PERIOD_STATEMENT_HINT_BALANCE_ADJUSTMENT:
    'Сума, списана з вашого балансу, коли використання було нижче мінімуму.',
  PERIOD_STATEMENT_HINT_RESULT: 'Чи досягнуто мінімуму і що було списано.',
  PERIOD_STATEMENT_HINT_UNUSED_MINIMUM: 'Мінімальне зобов’язання мінус використання.',
  PERIOD_STATEMENT_HINT_MINIMUM_MET: 'Використання досягло мінімуму. Додатково нічого не списували.',
  PERIOD_STATEMENT_HINT_DIFFERENCE_DEBITED:
    'Використання було нижче мінімуму. Невикористану частину списали з вашого балансу.',
  PERIOD_STATEMENT_HINT_PARTIALLY_DEBITED:
    'Використання було нижче мінімуму, але балансу вистачило лише на частину невикористаної суми.',
  PERIOD_STATEMENT_HINT_NOT_DEBITED: 'Використання було нижче мінімуму, але списати з балансу не вдалося.',

  USAGE_SERVICE_TRANSACTION_RISK_SCORE: 'Перевірка гаманця / транзакцій',
  USAGE_SERVICE_PROOF_OF_ADDRESS_RECOGNITION: 'Підтвердження адреси (за документом)',
  USAGE_SERVICE_PROOF_OF_ADDRESS_MATCH: 'Зіставлення підтвердження адреси',
  USAGE_SERVICE_BARCODE_CAPTURE: 'Зчитування штрих-коду',
  USAGE_SERVICE_CREDIT_CARD_CAPTURE: 'Зчитування кредитної картки',
  USAGE_SERVICE_SPECIFIC_DOCUMENT_CAPTURE: 'Зчитування нестандартного документа',
  USAGE_SERVICE_SELFIE_CAPTURE: 'Зйомка селфі',
  USAGE_SERVICE_FACE_CAPTURE: 'Зйомка обличчя',
  USAGE_SERVICE_SIGNATURE: 'Перевірка підпису',
  USAGE_SERVICE_OTP_VERIFICATION: 'OTP-перевірка',
  USAGE_SERVICE_UTILITY_BILL: 'Перевірка комунального рахунку',
  USAGE_SERVICE_DIIA: 'Дія',
  USAGE_SERVICE_FACE_MATCH: 'Зіставлення обличчя',
  USAGE_SERVICE_FACE_LIVENESS: 'Liveness',
  USAGE_SERVICE_DOCUMENT_CAPTURE: 'Перевірка ідентифікаційних даних',
  USAGE_SERVICE_CLEAN_DOCUMENT_CAPTURE: 'Зчитування документа',
  USAGE_SERVICE_RFID_DOCUMENT_CAPTURE: 'RFID-перевірка документа',
  USAGE_SERVICE_PASSIVE_FACE_MATCH: 'Зіставлення обличчя',
  USAGE_SERVICE_PASSIVE_LIVENESS: 'Liveness',
  USAGE_SERVICE_AML: 'Перевірка AML',
  USAGE_SERVICE_QUESTIONNAIRE: 'Анкета',
  USAGE_SERVICE_AML_MONITORING: 'Безперервний моніторинг (річний)',
  USAGE_SERVICE_AI_ASSISTANT_DOCUMENT: 'AI-асистент для документів',
  USAGE_SERVICE_EMAIL_OTP_VERIFICATION: 'Перевірка електронної пошти (otp)',
  USAGE_SERVICE_PHONE_HLR_VERIFICATION: 'HLR-перевірка телефону (перевірка оператора)',
  USAGE_SERVICE_PHONE_SMS_OTP_VERIFICATION: 'Перевірка телефону (sms)',
  USAGE_SERVICE_PHONE_VOICE_OTP_VERIFICATION: 'Перевірка телефону (дзвінок)',
  USAGE_SERVICE_EMAIL_VERIFICATION: 'Валідація електронної пошти',
  USAGE_SERVICE_PHONE_VERIFICATION: 'Перевірка телефону',
  USAGE_SERVICE_ADDRESS_RISK_SCORE: 'Перевірка гаманця / транзакцій',
  USAGE_SERVICE_TRANSACTION_MONITORING: 'Моніторинг гаманця',
  USAGE_SERVICE_PROOF_OF_ADDRESS: 'Перевірка адреси (без документів)',
  USAGE_SERVICE_FACE_MATCH_UNIQUENESS: 'Перевірка унікальної особи',

  SUBSCRIPTION_CANCELED: 'Підписку скасовано',
  SUBSCRIPTION_ENDED: 'Підписка завершена',
  SUBSCRIPTION_PAUSED: 'Підписку призупинено',
  PAYMENT_INCOMPLETE: 'Оплата не завершена',
  PAYMENT_EXPIRED: 'Термін оплати минув',
  REACTIVATE: 'Відновити',
  RESUME: 'Продовжити',
  COMPLETE_PAYMENT: 'Завершити оплату',
  CHOOSE_PLAN: 'Обрати план',
  DOWNGRADE_SUCCESS: 'Ваш план успішно знижено',

  NEW_PLAN_LABEL: 'Новий план',
  CHANGES: 'Зміни',
  UPGRADE_CREDITS_NOTE: 'Невикористані кредити будуть перенесені на новий план.',
  UPGRADE_BENEFITS_NOTE: 'Нові переваги стануть доступні одразу.',
  UPGRADE_UNDERSTAND_LABEL: 'Я розумію, як ця зміна може вплинути на мій білінг та використання',
  CONFIRM_UPGRADE: 'Підтвердити оновлення',

  DOWNGRADE_PLAN: 'Знизити план',
  DOWNGRADE_FEATURE_LIMITS: 'Нижчі ліміти використання',
  DOWNGRADE_FEATURE_ACCESS: 'Зменшений доступ до функцій',
  DOWNGRADE_BILLING_NOTE: 'Зниження плану набере чинності в наступному розрахунковому періоді.',
  DOWNGRADE_ACTIVE_NOTE: 'Ваш поточний план залишатиметься активним до того часу.',
  DOWNGRADE_UNDERSTAND_LABEL: 'Я розумію, що ліміти та функції мого плану можуть змінитися',
  CONFIRM_DOWNGRADE: 'Підтвердити зниження',

  CANCEL_SUBSCRIPTION_DESC_1:
    'Ваша підписка залишатиметься активною до кінця поточного розрахункового періоду.',
  CANCEL_SUBSCRIPTION_DESC_2: 'Після цього доступ до платних функцій буде обмежено.',
  CANCEL_UNDERSTAND_LABEL: 'Я розумію, що втрачу доступ до платних функцій після скасування',
  KEEP_PLAN: 'Залишити план',
  CANCEL_SUBSCRIPTION_SUCCESS: 'Вашу підписку буде скасовано {{date}}',

  RENEW_PLAN: 'Поновити план',
  RENEW_SUBSCRIPTION_TITLE: 'Поновити підписку?',
  RENEW_SUBSCRIPTION_DESC_1:
    'Вашу підписку скасовано. Вона залишатиметься активною до завершення поточного розрахункового періоду.',
  RENEW_SUBSCRIPTION_DESC_2: 'Бажаєте поновити підписку та й надалі користуватися сервісом без перерв?',
  RENEW_SUBSCRIPTION_CONFIRM: 'Поновити підписку',
  KEEP_CANCELLATION: 'Залишити скасування',
  RENEW_SUBSCRIPTION_SUCCESS: 'Вашу підписку поновлено',

  SCHEDULED_CANCEL: 'Ваш план буде скасовано {{date}}',
  SCHEDULED_UPGRADE: 'Ваш план буде підвищено до {{plan}} {{date}}',
  SCHEDULED_DOWNGRADE: 'Ваш план буде знижено до {{plan}} {{date}}',

  STATUS_TITLE_CANCELED: 'Підписку скасовано',
  STATUS_TITLE_ENDED: 'Підписка завершена',
  STATUS_TITLE_PAST_DUE: 'Прострочена оплата',
  STATUS_TITLE_PAUSED: 'Підписку призупинено',
  STATUS_SUBTITLE_INCOMPLETE: 'Підписка ще не активна',
  STATUS_SUBTITLE_INCOMPLETE_EXPIRED: 'Підписка не активована',

  STATUS_DESC_CANCELED: 'Вашу підписку скасовано. Доступ до функцій більше не доступний.',
  STATUS_DESC_ENDED: 'Термін вашої підписки закінчився. Поновіть для відновлення доступу.',
  STATUS_DESC_PAST_DUE: 'Не вдалося обробити ваш платіж. Будь ласка, спробуйте ще раз.',
  STATUS_DESC_PAUSED: 'Вашу підписку тимчасово призупинено. Оплата на паузі.',
  STATUS_DESC_INCOMPLETE: 'Завершіть оплату, щоб активувати підписку.',
  STATUS_DESC_INCOMPLETE_EXPIRED:
    'Термін попереднього налаштування минув. Почніть знову для активації підписки.',

  SIDEBAR_WARNING_CANCELED: 'Ваша підписка більше не активна.',
  SIDEBAR_WARNING_ENDED: 'Поповніть кредити або поновіть план для продовження використання сервісу.',
  SIDEBAR_WARNING_PAST_DUE: 'Оплата не пройшла. Перевірте платіжні дані, щоб уникнути перебоїв.',
  SIDEBAR_WARNING_UNPAID:
    'Ваші кредити закінчились. Для продовження використання сервісу, будь ласка, поповніть баланс.',
  SIDEBAR_WARNING_PAUSED: 'Наразі жодних платежів не обробляється.',

  PAYMENT_SUCCESS_TITLE: 'Готово!',
  PAYMENT_SUCCESS_DESCRIPTION: 'Усе виконано успішно.',
  PAYMENT_PENDING_TITLE: 'Очікування оплати',
  PAYMENT_PENDING_DESCRIPTION:
    'Ваш платіж перевіряється та буде підтверджений найближчим часом. Ви можете безпечно закрити це вікно.',
  PAYMENT_FAILED_TITLE: 'Щось пішло не так',
  PAYMENT_FAILED_DESCRIPTION: 'Не вдалося виконати ваш запит. Будь ласка, спробуйте ще раз.',
  TRY_AGAIN: 'Спробувати ще раз',
};
